module.exports = __webpack_public_path__ + "img/41.953cf187.jpg";